import {BaseAttribute} from "@/pages/AppPages/Events/attribute";
import { required } from "vuelidate/lib/validators";

export class TransferEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams)
        this.receiverOrganization = null;
        this.receiverOrganizationObject = {};
        this.receiverContractType = null;
        this.receiverContract = null;
        this.receiverContractObject = {};
        this.forLife = false;

        if (initObjectParams) {
            this.receiverOrganization = initObjectParams.receiverOrganization;
            this.receiverOrganizationObject = initObjectParams.receiverOrganizationObject;
            this.receiverContractType = initObjectParams.receiverContractType;
            this.receiverContract = initObjectParams.receiverContract;
            this.receiverContractObject = initObjectParams.receiverContractObject;
            this.forLife = initObjectParams.forLife;
        }
    }

    static get modelName() {
        return 'DisposalEvent'
    }

    static get validations() {
        return {
            receiverOrganization: { required },
            receiverContractType: { required },
            receiverContract: { required },
            forLife: {}
        }
    }

    static get validationFieldLabels() {
        return {
            receiverOrganization: 'Принимающая организация',
            receiverContractType: 'Тип контракта принимающей организации',
            receiverContract: 'Контракт принимающей организации',
            forLife: 'Пожизненно'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.receiverOrganization = data['receiverOrganization'];
        this.receiverContractType = data['receiverContractType'];
        this.receiverContract = data['receiverContract'];
        this.forLife = data['forLife'];
        this.receiverContractObject = data['receiverContractObject'];
        this.receiverOrganizationObject = data['receiverOrganizationObject'];

    }

}